import useWindowDimensions from "../../hooks/getWindowDimensions";
import Accordion from "../../ui/Accordion/Accordion";
import GlowingCircle from "../../ui/GlowingCircle/GlowingCircle";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import classes from "./FAQ.module.css";

const faqList = [
  {
    title: "General",
    questionsList: [
      {
        question: "What markets and instruments can I trade?",
        answer: (
          <>
            <p>Forex, indices and metals, and crypto pairs on MT5.</p>
          </>
        ),
      },
      {
        question: "What platforms are available to trade with?",
        answer: (
          <>
            <p>All trading is conducted on MetaTrader 5 (MT5)</p>
          </>
        ),
      },
      {
        question: "What swaps and commissions do you charge?",
        answer: (
          <p>
            No trading commissions or swaps on challenges. Swaps are charged on
            live-simulated accounts.
          </p>
        ),
      },
      {
        question:
          "How long does it take to receive my logins after purchasing or completing a stage?",
        answer: (
          <>
            <p>
              For Stage 1 and Stage 2 accounts, logins are typically issued <span>within minutes</span> of purchase or progression.
            </p>

            <p>
              For simulated live funded accounts, logins are generally provided <span>within 24 hours</span> after successful verification.
            </p>
          </>
        ),
      },
      {
        question: "Is there an age limit and country restriction?",
        answer: (
          <>
            <p>
              Minimum age: 18 years old. We do not accept residents from the
              USA, Canada, or OFAC-sanctioned countries.
            </p>
          </>
        ),
      },
      {
        question: "Can I trade news and hold overnight positions?",
        answer: (
          <>
            <p>
              Yes. News trading, overnight holds, and weekend positions are
              allowed.
            </p>
          </>
        ),
      },
      {
        question:
          "Do you offer refunds on challenge fees once a challenge is passed?",
        answer: (
          <>
            <p>
              No, challenge fees are non-refundable. These fees are used to
              build the Community Pool, which funds trader payouts and maintains
              platform sustainability. In return, funded traders benefit not
              only from 100% profit payouts but also become eligible for annual
              airdrops.
            </p>
          </>
        ),
      },
    ],
  },
  {
    title: "Rules",
    questionsList: [
      {
        question: "What are the trading rules?",
        answer: (
          <>
            <p>2-Step Challenge Model:</p>

            <ul>
              <li>Step 1: 8% profit target, 4% daily loss, 8% max loss</li>
              <li>Step 2: 4% profit target, 4% daily loss, 8% max loss</li>
              <li>Funded Stage: 10% monthly profit cap, 8% max loss</li>
            </ul>
          </>
        ),
      },
      {
        question: "How is the daily loss calculated?",
        answer: (
          <>
            <p>
              Daily loss is based on the lowest equity (including open trades)
              reached during any 24-hour trading day, measured from that day's
              starting balance.
            </p>
          </>
        ),
      },
      {
        question: "Can I trade during news releases?",
        answer: (
          <p>
            Yes. News trading is fully allowed as long as you respect all risk
            parameters.
          </p>
        ),
      },
      {
        question: "What constitutes 'Trading according to a real market'?",
        answer: (
          <p>
            Trading must reflect sustainable risk management. Banned practices
            include the use of martingale strategies (unless a 1.5x add-on cap
            is purchased), copy trading, arbitrage bots, and latency exploit.
          </p>
        ),
      },
      {
        question:
          "Are there specific conditions I must meet to maintain my account?",
        answer: (
          <p>
            Maintain compliance with drawdown rules, avoid any disallowed
            strategies, and ensure active trading in accordance with platform
            guidelines.
          </p>
        ),
      },
    ],
  },
  {
    title: "Withdrawals",
    questionsList: [
      {
        question: "How can I withdraw my profits?",
        answer: (
          <>
            <p>Withdrawals are submitted directly via your portal dashboard.</p>
          </>
        ),
      },
      {
        question: "How long does it take for my withdrawal to be processed?",
        answer: (
          <p>
            Withdrawal requests are typically processed <span>within 24 hours.</span>
          </p>
        ),
      },
      {
        question: "Are there any minimums required to request a withdrawal?",
        answer: <p>Yes — the minimum withdrawal request amount is $100.</p>,
      },
      {
        question: "What payment methods are accepted for withdrawals?",
        answer: (
          <p>Crypto (USDT primarily), sent directly to your wallet address.</p>
        ),
      },
      {
        question: "Are there any fees associated with withdrawals?",
        answer: (
          <p>
            Yes — a <span>1.5% withdrawal processing fee</span> is applied
            to each payout request. This helps cover transaction and admin
            costs.
          </p>
        ),
      },
      {
        question: "When can I request a withdrawal?",
        answer: (
            <p>
              First withdrawal: after 30 days from your first trade. <br/>After that,
              you are eligible every 14 days.
            </p>
        ),
      },
      {
        question: "Are withdrawals subject to taxes?",
        answer: (
            <p>
              Traders are responsible for any taxes based on their jurisdiction. PropTrading.Fun does not handle tax filings.
            </p>
        ),
      },
    ],
  },
];

const FAQ = () => {
  const { height, width } = useWindowDimensions();
  return (
    <>
      <Header faq={true} />
      <div className={`d-flex justify-content-center ${classes.wrapper}`}>
        <div
          className={`d-flex justify-content-center align-items-center m-0 ${classes.overlay}`}
        >
          <div className={classes.infoContainer}>
            <div className={classes.titleContainer}>
              <h1>Frequently Asked Questions</h1>
            </div>
            {faqList.map((faq, index) => (
              <div
                className={`${classes.faqContainer} mt-4 d-flex flex-md-row flex-column justify-content-md-between`}
                key={index}
              >
                <div>
                  <h3>{faq.title}</h3>
                </div>
                <div>
                  {faq.questionsList.map((item, i) => (
                    <Accordion
                      title={item.question}
                      content={item.answer}
                      key={i}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <GlowingCircle className={classes.glow} />
      </div>
      <Footer />
    </>
  );
};

export default FAQ;
